// Lifecycle of one company's brief for one week. A brief is built Monday 06:00
// (Europe/Amsterdam) and ends in exactly one terminal state: sent, skipped,
// failed, rejected or expired.
// Who built the brief: the Monday 06:00 job (once per company per week) or a
// super admin's Build now (any number of times).
export enum WeeklyBriefTrigger {
  Schedule = 'schedule',
  Manual = 'manual',
}

export enum WeeklyBriefStatus {
  // Quiet week or too little data - nothing was generated or sent.
  Skipped = 'skipped',
  // Data fetch, generation or sending failed.
  Failed = 'failed',
  // Built and waiting for a super admin to approve or reject it.
  PendingApproval = 'pending_approval',
  // Approved (by a super admin, or automatically) and waiting for the send.
  Approved = 'approved',
  // Claimed by a sender; guards against the send job and a late approval both sending.
  Sending = 'sending',
  Sent = 'sent',
  Rejected = 'rejected',
  // Never approved before the next week's brief was built.
  Expired = 'expired',
}
